import React from 'react'
import { Redirect } from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import ServiceCategoryForm from './ServiceCategoryForm'
import ServiceCategoryCard from './ServiceCategoryCard'

import Resource from '../../stores/resource'
const CategoryStore = Resource('service-categories')

class NewServiceCategory extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      serviceCategory: this.props.attributes || {},
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = attributes => {
    CategoryStore.create(attributes)
      .then(result => {
        this.setState(
          {
            saved: true,
            error: '',
            savedServiceCategory: result.data.data,
            snackbarMessage: `Service category "${attributes.name}" created!`
          },
          () => {
            if (this.props.savedCallback) {
              this.props.savedCallback(this.state.savedServiceCategory)
            }
          }
        )
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _closeErrorDialog = () => this.setState({ error: '' })

  _closeSuccessDialog = () => this.setState({ redirect: `/service-categories` })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    const {
      redirect,
      saved,
      snackbarMessage,
      error,
      serviceCategory,
      savedServiceCategory
    } = this.state

    const name = serviceCategory.attributes
      ? serviceCategory.attributes.name
      : ''

    const {
      formTitle,
      forceChanged,
      cancelCallback,
      showSuccessDialog
    } = this.props

    if (redirect) return <Redirect push to={redirect} />

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog} />
    ]

    return (
      <section>
        <ServiceCategoryForm
          formTitle={formTitle}
          name={name}
          forceChanged={forceChanged}
          submitCallback={this._save}
          cancelCallback={cancelCallback}
        />
        <br />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create service category"
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved &&
          showSuccessDialog && (
            <Dialog
              actions={successDialogActions}
              modal={false}
              onRequestClose={this._closeSuccessDialog}
              open={Boolean(saved)}
              title="Service category created"
            >
              <p>
                A new service category has been created with the information
                below.<br />
                If you see any incorrect information, press the{' '}
                <strong>Edit</strong> button.
              </p>
              <ServiceCategoryCard
                serviceCategory={savedServiceCategory}
                editCallback={() =>
                  this._redirectTo(
                    `/service-categories/${savedServiceCategory.id}/edit`
                  )
                }
              />
            </Dialog>
          )}
      </section>
    )
  }
}

export default NewServiceCategory



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/NewServiceCategory.jsx